import Vue from 'vue'
import mk from './MK'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import db from 'utils/localstorage'
import VueApexCharts from 'vue-apexcharts'
import animated from 'animate.css'
import '../static/iconfont/font.css'
import '../static/iconfont/iconfont.js'
import global_ from './components/tool/Global'//全局常量
Vue.prototype.GLOBAL = global_

import FullCalendar from 'vue-full-calendar'
Vue.use(FullCalendar)

import 'ant-design-vue/dist/antd.less'

import 'utils/install'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueApexCharts)
Vue.use(animated)

Vue.component('apexchart', VueApexCharts)

Vue.use({
  install (Vue) {
    Vue.prototype.$db = db
  }
})


router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

Vue.prototype.$post = request.post
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$stream = request.stream

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(mk)
}).$mount('#mk')



// WEBPACK FOOTER //
// ./src/main.js